import { makeStyles } from '@material-ui/core';

export const modalStyles = makeStyles((theme) => ({
    modalWrapper: {
        padding: '4rem 1.5rem',
        '& .modal': {
            '&-container': {
                height: '100%', 
                
            },
            '&-inner': {
                height: '100%',
                width: '100%',
                maxWidth: '50rem',
                overflow: 'hidden',
                margin : '0 auto',

                '& > button': {
                    color: 'white',
                    alignSelf: 'flex-end',
                    marginBottom: theme.spacing(.5),

                },

            },
            '&-close': {
                display: 'flex',
                justifyContent: 'flex-end',
                '&-button': {
                    color: 'white',
                    alignSelf: 'flex-end',
                    marginBottom: theme.spacing(.5),
                    background: 'transparent',
                    padding: '0',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',

                    fontFamily: 'sans-serif',
                    '& svg': {
                        height: '.875rem',
                        width: '.875rem',
                        marginLeft: theme.spacing(.5),
                        fill: 'white',
                    },
                },
            },
            '&-content': {
                height: '100%',
                '&-inner': {
                    overflow: 'auto',
                    borderRadius: '3px',
                    padding: theme.spacing(1.5),
                    background: 'white',
                    boxShadow: '0px 12px 24px rgba(48, 48, 48, 0.3)',
                    maxHeight:'100%',
                },
                '&-title': {
                    marginBottom: theme.spacing(.75),
                },
                '&-subtitle': {
                    marginBottom: theme.spacing(.5),
                },
           
            },
            '&-file-link': {
                marginTop: theme.spacing(1),
            },
        },

    },



}));



